// extracted by mini-css-extract-plugin
module.exports = {"root":"GroupList-module__root__3lGTt","title":"GroupList-module__title__2rXCD","items":"GroupList-module__items__2cooa"};